<template>
    <section class="ui-overlay-load" :style="opacityCss" @click="callback($event)">
        <div class="box">
            <ui-load-indicator bg-color="#FFF" :color="color" :h="size" :stroke="stroke"/>
            <div v-if="text" class="text">
                <span>{{text}}</span>
            </div>
        </div>
    </section>
</template>

<script>
	import uiLoadIndicator from '@/components/ui/load-indicator'
    export default {
		name: 'ui-overlay-load',
		components: { uiLoadIndicator },
		props:{
            opacity: {
                type: Number,
                required: false,
                default: 0.1,
			},
			text: {
				type: String,
				required: false,
				default: ''
			},
			size: {
				type: Number,
				required: false,
				default: 50
			},
			stroke: {
				type: Number,
				required: false,
				default: 8
			},
			color: {
				type: String,
				required: false,
				default: "#69D296"
			},
			/**
			 * Necessario inserir background com rgba para pegar a opacidade  neste padrão => rgba(#,#,#,
			 */
			backgroundColorOverlay: {
				type: String,
				required: false,
				default: 'rgba(80,80,120,'
			},
			onClick: {
				type: Function,
			}

		},
		data() {
            return {
				opacityCss: {
					backgroundColor: `${this.backgroundColorOverlay}${this.opacity})`
				}
            }
		},
		methods:{
			callback: function(e) {
				this.$emit('click', e);
			}
		}
	};
</script>

<style lang="stylus" scoped>
	@import './styles.styl';

</style>
